if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('keyup', (event) => {
        if (event.code === 'Escape') this.close();
      });
      this.addEventListener('click', (event) => {
        if (event.target.closest('#CartDrawer-Overlay')) this.close();
      });
      this.setHeaderCartIconAccessibility();
    }

    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector('#cart-icon-bubble');
      if (!cartLink || cartLink.dataset.cartDrawerBound === 'true') return;
      cartLink.dataset.cartDrawerBound = 'true';
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.setAttribute('aria-expanded', 'false');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code === 'Space' || event.code === 'Enter') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }

    open(triggeredBy, force) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      if (this.classList.contains('active') && !force) return;

      const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
      if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

      this.classList.add('active');
      requestAnimationFrame(() => this.classList.add('animate'));
      document.body.classList.add('overflow-hidden');

      const cartLink = document.querySelector('#cart-icon-bubble');
      if (cartLink) cartLink.setAttribute('aria-expanded', 'true');

      window.setTimeout(() => {
        if (!this.classList.contains('active')) return;
        const container = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : this.querySelector('#CartDrawer');
        const focusElement = this.querySelector('.drawer__close') || this.querySelector('.drawer__inner');
        if (container && focusElement) trapFocus(container, focusElement);
      }, 220);
      this.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
    }

    close() {
      this.classList.remove('active');
      removeTrapFocus(this.activeElement);
      document.body.classList.remove('overflow-hidden');
      const cartLink = document.querySelector('#cart-icon-bubble');
      if (cartLink) cartLink.setAttribute('aria-expanded', 'false');
      this.dispatchEvent(new CustomEvent('cart-drawer:close', { bubbles: true }));
    }

    setSummaryAccessibility(summary) {
      summary.setAttribute('role', 'button');
      summary.setAttribute('aria-expanded', 'false');
      if (summary.nextElementSibling && summary.nextElementSibling.id) summary.setAttribute('aria-controls', summary.nextElementSibling.id);
      summary.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', String(!event.currentTarget.closest('details').hasAttribute('open')));
      });
      summary.parentElement.addEventListener('keyup', onKeyUpEscape);
    }

    renderContents(parsedState) {
      this.classList.remove('is-empty');
      this.productId = parsedState.id;

      this.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        const sectionMarkup = parsedState.sections && parsedState.sections[section.id];
        if (!sectionElement || !sectionMarkup) return;
        sectionElement.innerHTML = this.getSectionInnerHTML(sectionMarkup, section.selector);
      });

      this.setHeaderCartIconAccessibility();
      requestAnimationFrame(() => this.open(null, true));
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const source = documentFragment.querySelector(selector);
      return source ? source.innerHTML : '';
    }

    getSectionsToRender() {
      return [
        { id: 'cart-drawer', selector: '#CartDrawer' },
        { id: 'cart-icon-bubble' }
      ];
    }

    setActiveElement(element) {
      this.activeElement = element;
    }
  }

  customElements.define('cart-drawer', CartDrawer);
}

if (!customElements.get('cart-drawer-items')) {
  class CartDrawerItems extends CartItems {
    getSectionsToRender() {
      return [
        { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
        { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
      ];
    }
  }
  customElements.define('cart-drawer-items', CartDrawerItems);
}
